/* istanbul ignore file */
export { WindowRefModule } from './window-ref.module';
export { WindowRef } from '../../services/window-ref/window-ref.service';
export { MockWindowRef } from '../../services/window-ref/window-ref.service.mock';
